import React from 'react';
import PropTypes from 'prop-types';
import {
    Dialog,
    DialogContent,
    DialogActions,
    IconButton,
    Box,
    Typography,
    Button,
} from '@mui/material';
import {LoadingButton} from '@mui/lab';
import CloseIcon from '@mui/icons-material/Close';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import {ezprOrange} from '../_helpers';

// eslint-disable-next-line require-jsdoc
export function AccessCatalogueDialog(props) {
    return (
        <Dialog
            open={props.open}
            onClose={props.onClose}
            sx={{
                '& .MuiPaper-root': {borderRadius: '10px'},
            }}
            PaperProps={{
                sx: {
                    borderRadius: '10px',
                    overflow: 'hidden',
                },
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    backgroundColor: ezprOrange,
                    px: 2,
                    py: 1,
                    marginBottom: '1rem',
                }}
            >
                <Typography variant="h6" sx={{color: '#fff'}}>
                    {props.title}
                </Typography>
                <IconButton onClick={props.onClose} sx={{color: '#fff'}}>
                    <CloseIcon />
                </IconButton>
            </Box>

            <DialogContent sx={{display: 'flex', alignItems: 'center', pt: 3, pb: 2, px: 3}}>
                <Box
                    sx={{
                        mr: 3,
                        border: `2px solid ${ezprOrange}`,
                        borderRadius: '50%',
                        p: 1,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <ShoppingCartOutlinedIcon sx={{fontSize: 40, color: ezprOrange}} />
                </Box>
                <Box>
                    <Typography variant="body1" sx={{mb: 1, color: '#212121', fontWeight: 500}}>
                        {props.headline}
                    </Typography>
                    <Typography variant="body1" sx={{color: '#757575'}}>
                        {props.body}
                    </Typography>
                </Box>
            </DialogContent>

            <DialogActions sx={{px: 3, pb: 3, justifyContent: 'flex-end', marginTop: '2rem'}}>
                <Button onClick={props.onSkip} sx={{color: '#757575', textTransform: 'none'}}>
                    Skip & Continue
                </Button>
                <LoadingButton
                    variant="contained"
                    onClick={props.onAccess}
                    loading={props.loading}
                    sx={{
                        'ml': 2,
                        'backgroundColor': ezprOrange,
                        'textTransform': 'uppercase',
                        '&:hover': {backgroundColor: ezprOrange},
                        'color': '#ffffff',
                    }}
                >
                    Access Supplier Catalog
                </LoadingButton>
            </DialogActions>
        </Dialog>
    );
}

AccessCatalogueDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onSkip: PropTypes.func.isRequired,
    onAccess: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    title: PropTypes.string,
    headline: PropTypes.string.isRequired,
    body: PropTypes.string.isRequired,
};

AccessCatalogueDialog.defaultProps = {
    loading: false,
    title: 'Access Catalog',
};
